module.exports = __webpack_public_path__ + "static/media/PoppinsRegular.8e9327cb.eot";